import { STATUS_TYPE } from '../../../enum';
import { Users } from '../../users/api/interfaces';

export interface FindUserList {
  isUser?: boolean;
  search?: string;
  limit?: number;
  skip?: number;
  isApproved?: boolean;
  userRole?: string;
}

export interface InitialState {
  data: Users[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
